import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "folder-meta-bar" }
const _hoisted_2 = { class: "duration-badge" }
const _hoisted_3 = { class: "music-list-scroll" }
const _hoisted_4 = { class: "track-number" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "track-info" }
const _hoisted_7 = { class: "track-name" }
const _hoisted_8 = { class: "track-duration" }
const _hoisted_9 = { class: "track-actions" }
const _hoisted_10 = { class: "play-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "music-library-folder-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    "default-href": "/music-library",
                    text: ""
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.folderTitle), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background-dark music-library-folder-content",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "release-safe-area" }, null, -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ion_icon, { icon: _ctx.timeOutline }, null, 8, ["icon"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.mediaUtils.formatTime(_ctx.mediaUtils.getTotalPlaylistDuration(_ctx.musicList))), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ion_list, {
              class: "bg-transparent music-library-track-list",
              lines: "none"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.musicList, (audioTrack, idx) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: audioTrack.id,
                    class: _normalizeClass(["music-item music-library-track-item", { playing: _ctx.isTrackRowActive(idx) }]),
                    onClick: ($event: any) => (_ctx.selectTrack(idx))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        (!_ctx.isTrackRowActive(idx))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(idx + 1), 1))
                          : (_openBlock(), _createBlock(_component_ion_icon, {
                              key: 1,
                              icon: _ctx.play,
                              class: "playing-icon"
                            }, null, 8, ["icon"]))
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.mediaUtils.getTrackName(audioTrack)), 1),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.mediaUtils.formatTime(audioTrack.duration)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.isTrackRowActive(idx) ? _ctx.pause : _ctx.play,
                            class: "play-icon"
                          }, null, 8, ["icon"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                }), 128))
              ]),
              _: 1
            }),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "fake-footer" }, null, -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}